import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * 홈 대시보드 좌측 — 내 공부 이어가기 (JCG-2110, 신규 IA).
 *
 * 개인별 "마지막으로 본 글" 데이터 소스가 아직 없어, 지금은 정직하게 학습 현황 페이지로
 * 안내하는 CTA 카드로 둔다(허위 진도 표기 금지). 추후 최근 학습 기록이 연결되면 이 카드에서
 * 실제 진도/이어보기 링크를 노출하도록 확장한다(후속 이슈).
 */
export default function ContinueLearningCard({
  compact = false,
}: {
  compact?: boolean;
}) {
  return (
    <Link
      href="/my/study-progress"
      className={cn(
        "group block border border-sky-200 bg-sky-50/70 transition-colors hover:bg-sky-100/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 dark:border-sky-900 dark:bg-sky-950/30 dark:hover:bg-sky-950/50",
        compact ? "h-full rounded-2xl p-3" : "rounded-3xl p-4",
      )}
    >
      <p className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-sky-600 dark:text-sky-400">
        내 공부 이어가기
      </p>
      <div className="flex items-center gap-3">
        <Image
          src="/main/study_gamza.webp"
          alt=""
          width={40}
          height={40}
          className={cn(
            "shrink-0 rounded-xl object-contain",
            compact ? "h-9 w-9" : "h-10 w-10",
          )}
        />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold leading-snug text-foreground">
            공부 진행상황 보기
          </p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            어디까지 했는지 한눈에 확인해요
          </p>
        </div>
        <ArrowRight className="h-4 w-4 shrink-0 text-sky-400 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </div>
    </Link>
  );
}
